import React, { useState } from 'react'
import { useDataUsuarioSelected } from '../../../../Hooks/Admin/useContextos';
import { CustomTable } from '../../../../Components/Admin/CustomTable';
import { usePokemonesUsuarioTable, useSelectPokemon } from '../../../../Hooks/Admin';
import { camposFormulario, camposFormularioCrear, columns } from './Helpers/listarPokemonesHelper';
import { ExportOutlined, SwapOutlined } from '@ant-design/icons';
import { useObtenerPokemonUsuario } from '../queries/querysUsuario';
import { Card, Modal } from 'antd';
import { ModalTransferirPokemon } from './Helpers/ModalTransferirPokemon';
import { useMediaQuery } from 'react-responsive';
import { ModalLiberarPokemon } from './Helpers/ModalLiberarPokemon';
import { useLiberarPokemon } from '../../../../Hooks/Admin/useDeleteHooks';

export const PokemonesUsuario = () => {
    const { selectedId } = useDataUsuarioSelected();

    const isDesktopOrLaptop = useMediaQuery({
        query: "(min-device-width: 1224px)",
    });

    const [pokemonSelected, setPokemonSelected] = useState(null);
    const [codigos, setCodigos] = useState([]);

    const [openTransferirModal, setOpenTransferirModal] = useState(false)
    const [openLiberarModal, setOpenLiberarModal] = useState(false)
    const [actualFila, setActualFila] = useState(null)

    const queryPokemonSelect = useSelectPokemon();

    const handleRefresh = () => {
        // La tabla se refrescará automáticamente debido a la invalidación de queries
    };

    const acciones = () => {
        return [
            {
                label: "Transferir",
                key: 1,
                icon: <SwapOutlined />,
                onClick: (e) => {
                    setOpenTransferirModal(true)
                }
            }
        ]
    }

    return (
        <>
            {
                selectedId ?
                    <>
                        <CustomTable
                            queryListar={usePokemonesUsuarioTable}
                            camposFilter={camposFormulario()}
                            perPage={5}
                            columns={columns()}
                            basicParams={{ idUsuario: selectedId, page: 1, perPage: 5 }}
                            externalParams={{ idUsuario: selectedId }}
                            tituloTabla="Pokemones del usuario"
                            tituloEditar={"Transferir"}
                            columnNameEditar='Transferir'
                            iconEditar={
                                <SwapOutlined />
                            }
                            camposAgregar={camposFormularioCrear(queryPokemonSelect.data, codigos, selectedId, setPokemonSelected)}
                            queryCrear={useObtenerPokemonUsuario}
                            canDelete={true}
                            queryBorrarFila={useLiberarPokemon}
                            accionesList={acciones()}
                            onClickActions={(data) => setActualFila(data)}
                        />
                    </> : <>
                        <Card title="Elije un usuario para poder interactuar con esta pestaña" />
                    </>
            }
            <Modal
                title={`Transferir Pokémon`}
                open={openTransferirModal}
                footer={null}
                onCancel={() => {
                    setOpenTransferirModal(false)
                    setActualFila(null)
                }}
                cancelText="Cancelar"
                width={isDesktopOrLaptop ? "50%" : "100%"}
            >
                {
                    actualFila && <ModalTransferirPokemon data={actualFila} setRefetch={handleRefresh} setModal={setOpenTransferirModal} />
                }
            </Modal>
            <Modal
                title={`Liberar Pokémon`}
                open={openLiberarModal}
                footer={null}
                onCancel={() => {
                    setOpenLiberarModal(false)
                    setActualFila(null)
                }}
                cancelText="Cancelar"
                width={isDesktopOrLaptop ? "50%" : "100%"}
            >
                {
                    actualFila && <ModalLiberarPokemon data={actualFila} setRefetch={handleRefresh} setModal={setOpenLiberarModal} />
                }
            </Modal>

        </>
    )
}
